import React, { useEffect, useState } from "react";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import getPermission from "../../api/user/getPermission";
import setPermissionApi from "../../api/user/setPermission";
import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Typography,
  Select,
  MenuItem,
  Card,
  CardContent,
} from "@mui/material";
import getAllStore from "../../api/store/getAllStore";
function PermissionPage() {
  const [user, setUser] = useState(null);
  const [searchPhone, setSearchPhone] = useState("");
  const [error, setError] = useState(null);
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [permission, setPermission] = useState([]);
  const roles = ["Moderator", "Support"];

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const data = await getAllStore();

        setStores(data.stores);
      } catch (err) {
        setError("取得店家資料失敗");
      }
    };

    if (stores) {
      fetchStores();
    }
  }, []);
  const handleSearch = async () => {
    try {
      const fetchedUser = await getPermission(searchPhone);

      setUser(fetchedUser.user_id);
      if (fetchedUser.permission === null) {
        setPermission([]);
      } else {
        setPermission(fetchedUser.permission);
      }

      setError(null);
    } catch (err) {
      setUser(null);
      setError("無法取得權限資料");
    }
  };
  const handleStoreListChange = (event) => {
    const { name, value } = event.target;

    setSelectedStore(value);
  };
  const handleRoleListChange = (event) => {
    const { name, value } = event.target;

    setSelectedRole(value);
  };
  const handleAddButtonClicked = async () => {
    // Check if the selectedStore already exists in the permissions
    const exists = permission.some((p) => p.store === selectedStore);

    // If it doesn't exist, then add a new permission
    if (!exists) {
      const newPermission = { store: selectedStore, resource: "", action: "" };
      setPermission((prevPermissions) => {
        const updatedPermissions = [...prevPermissions, newPermission];

        // Call setPermissionApi with the updated permissions
        setPermissionApi(user, updatedPermissions,selectedRole)
          .then(() => {
            // Handle success, e.g., show success message or further update the UI
          })
          .catch((error) => {
            // Handle error, e.g., show error message or update error state
            setError("Error updating permissions");
          });

        return updatedPermissions;
      });
    } else {
      setError("店家已經存在");
    }
  };
  const handleConfirmButtonClicked = async () => {
    setPermissionApi(user, permission,selectedRole)
    .then(() => {
      // Handle success, e.g., show success message or further update the UI
    })
    .catch((error) => {
      // Handle error, e.g., show error message or update error state
      setError("Error updating permissions");
    });
  };
  const PermissionList = () => {
    return (
      <Box marginLeft={1}>
        {permission?.map((p, index) => {
          return (
            <Stack
              alignItems="center"
              direction={"row"}
              key={"permission" + index}
              justifyContent={"space-between"}
            >
              <Typography>{p.store || ""}</Typography>
              <IconButton
                onClick={async () => {
                  const previousPermissions = [...permission]; // Capture the current state before deleting
                  const newPermissions = previousPermissions.filter(
                    (_, i) => i !== index
                  );

                  setPermission(newPermissions);

                  // Call setPermissionApi with the updated permissions
                  try {
                    await setPermissionApi(user, newPermissions,"");
                    // Handle success, e.g., show success message or further update the UI
                  } catch (error) {
                    // If API call fails, revert to previous state
                    setPermission(previousPermissions);
                    // Handle error, e.g., show error message or update error state
                    setError("Error updating permissions");
                  }
                }}
              >
                <RemoveCircleRoundedIcon color="error" />
              </IconButton>
            </Stack>
          );
        })}
      </Box>
    );
  };
  const StoreSelect = () => {
    return (
      <>
        <Select
          variant="outlined"
          color="secondary"
          sx={{ background: "#ffffff", minWidth: 180 }}
          value={selectedStore || ""}
          onChange={handleStoreListChange}
          label="店家"
        >
          {stores?.map((store, index) => {
            return (
              <MenuItem key={"menu" + store.Code} value={store.Code}>
                {store.Code + ":" + store.Name}
              </MenuItem>
            );
          })}
        </Select>
      </>
    );
  };
  const RoleSelect = () => {
    return (
      <>
        <Select
          variant="outlined"
          color="secondary"
          sx={{ background: "#ffffff", minWidth: 180 }}
          value={selectedRole || ""}
          onChange={handleRoleListChange}
          label="角色"
        >
          {roles?.map((role, index) => {
            return (
              <MenuItem key={"role" + index} value={role}>
                { role ==="Moderator"? "管理者":"客服"}
              </MenuItem>
            );
          })}
        </Select>
      </>
    );
  };
  return (
    <div>
      <Card sx={{ margin: "1px" }}>
        <CardContent>
          <Typography marginY={2} fontWeight={"bold"}>
            {"1.搜尋用戶："}
          </Typography>
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <TextField
              label="輸入用戶手機號碼"
              variant="outlined"
              color="secondary"
              sx={{ background: "#ffffff" }}
              value={searchPhone}
              onChange={(e) => setSearchPhone(e.target.value)}
            />
            <Button
              onClick={handleSearch}
              variant="contained"
              color="secondary"
            >
              搜尋
            </Button>
          </Stack>
        </CardContent>
      </Card>

      {error && (
        <Card sx={{ margin: "1px", marginTop: 1 }}>
          <CardContent>
            <Typography
              color="error"
              fontWeight={"bold"}
              style={{ marginTop: "20px" }}
            >
              {error}
            </Typography>
          </CardContent>
        </Card>
      )}
      <Card sx={{ margin: "1px", marginTop: 1 }}>
        <CardContent>
          <Typography marginY={2} fontWeight={"bold"}>
            {"2.用戶權限："}
          </Typography>

          {PermissionList()}
          <Stack direction={"row"} alignItems={"center"} marginTop={5}  spacing={1}>
          <Typography marginY={2}  fontWeight={"bold"}>
            {"角色:"}
          </Typography>
          {RoleSelect()}
          <Button
              onClick={handleConfirmButtonClicked}
              variant="contained"
              color="secondary"
              sx={{marginLeft:1}}
            >
              確認
            </Button>
          </Stack>

          <Stack direction={"row"} alignItems={"center"} marginTop={2} spacing={1}>
          <Typography marginY={2} fontWeight={"bold"}>
            {"店家:"}
          </Typography>
            {StoreSelect()}

            <Button
              onClick={handleAddButtonClicked}
              variant="contained"
              color="secondary"
            >
              新增
            </Button>
          </Stack>

        </CardContent>
      </Card>
    </div>
  );
}

export default PermissionPage;
